<script setup>
import { useToggle } from '@vueuse/core';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultOpen: {
    type: Boolean,
    default: true,
  },
});

const [isOpen, toggle] = useToggle(props.defaultOpen);
</script>

<template>
  <div
    v-bind="$attrs"
    class="flex w-full cursor-pointer items-center justify-between border-t border-auth-border pb-2 pt-4 dark:border-auth-border-dark"
    @click="toggle()"
  >
    <span class="w-full text-heading-2 text-auth-text dark:text-auth-text-dark">
      {{ title }}
    </span>
  </div>
  <div v-if="isOpen" class="w-full space-y-4 pt-4 mb-4">
    <slot />
  </div>
</template>
